module.exports = __webpack_public_path__ + "img/banner-b4@1x.eae031a4.jpg";